var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("default", function () {
        return [_c("div", [_vm._v("Название поля")])]
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: _setup.props.classinput },
        [
          _c(_setup.multiselect, {
            staticClass: "MyMulti",
            attrs: {
              value: _setup.vals,
              options: _setup.props.list,
              label: "name",
              "track-by": "id",
              placeholder: _setup.props.placeholder,
              multiple: !_setup.props.onlyone,
              searchable: true,
              "close-on-select": _setup.props.onlyone ? true : false,
              "clear-on-select": false,
              selectLabel: "Выбрать",
              selectedLabel: "Выбрано",
              deselectLabel: "Убрать",
            },
            on: { input: _setup.select },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function ({ option, search, index }) {
                  return [
                    _c("span", { staticClass: "opt" }, [
                      _c("span", { staticClass: "c che" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "checkbox__check",
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("polyline", {
                              attrs: { points: "20 6 9 17 4 12" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "checkbox", checked: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              )
                                return null
                              $event.preventDefault()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "c noche" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "checkbox__check",
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("polyline", {
                              attrs: { points: "20 6 9 17 4 12" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "checkbox" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              )
                                return null
                              $event.preventDefault()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(option.name)),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "noResult",
                fn: function ({ search }) {
                  return [_vm._v("\n                Не найдено\n            ")]
                },
              },
              {
                key: "selection",
                fn: function ({ remove, values, isOpen }) {
                  return [
                    isOpen
                      ? _c(
                          "div",
                          [
                            _setup.props.onlyone
                              ? [
                                  _setup.vals
                                    ? _c("span", { staticClass: "word" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "clear",
                                            on: {
                                              keypress: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return remove(_setup.vals)
                                              },
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                                return remove(_setup.vals)
                                              },
                                            },
                                          },
                                          [_c(_setup.Delete)],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_setup.vals.name)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._l(values, function (v) {
                                  return _c("span", { staticClass: "word" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "clear",
                                        on: {
                                          keypress: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return remove(v)
                                          },
                                          mousedown: function ($event) {
                                            $event.preventDefault()
                                            return remove(v)
                                          },
                                        },
                                      },
                                      [_c(_setup.Delete)],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(v.name))]),
                                  ])
                                }),
                          ],
                          2
                        )
                      : _c("div", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_setup.optionText(values)) +
                              "\n                "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }